<template lang='pug'>
  div
    label
      | Type
    .divider_container
      el-select(
        v-model='type'
        @change='on_type_changed($event)')
        el-option(
          v-for="option in types"
          :key="option.value"
          :label="option.label"
          :value="option.value")
    .divider_container
      label
        | Color
      pbxx_color_picker(
        :color='color'
        @input='on_color_changed')
    .divider_container
      label
      | Thickness
      el-slider(
        :min=1
        :max=15
        v-model='thickness'
        @change='on_thickness_changed')
    .divider_container
      label
        | Vertical Spacing
      el-slider(
        :min=0
        :max=30
        v-model='spacing'
        @change='on_spacing_changed')
</template>
<script>
  export default {
    name: 'divider',
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        color: this.landing_page_widget.draft_content.color === 'transparent' ? '' : this.landing_page_widget.draft_content.color,
        type: this.landing_page_widget.draft_content.type,
        types: [
          { value: 'normal', label: 'Solid' },
          { value: 'gradient', label: 'Gradient' },
          { value: 'dotted', label: 'Dotted' },
        ],
        thickness: this.landing_page_widget.draft_content.thickness,
        spacing: this.landing_page_widget.draft_content.spacing
      }
    },
    methods: {
      initialized(event, editor){
        this.editor = editor
      },
      insert_variable(cmd, val) {
        this.editor.html.insert(`{{ ${val} }}`)
      },
      on_type_changed(type) {
        this.type = type
        const widget = {...this.landing_page_widget}
        widget.draft_content.type = type
        this.$emit('input', widget)
      },
      on_color_changed(color) {
        this.color = color
        const widget = {...this.landing_page_widget}
        widget.draft_content.color = color
        this.$emit('input', widget)
      },
      on_thickness_changed(thickness) {
        this.thickness = thickness
        const widget = {...this.landing_page_widget}
        widget.draft_content.thickness = thickness
        this.$emit('input', widget)
      },
      on_spacing_changed(spacing) {
        this.spacing = spacing
        const widget = {...this.landing_page_widget}
        widget.draft_content.spacing = spacing
        this.$emit('input', widget)
      },
    }
  }
</script>

<style>
  .divider_container {
    margin-bottom: 20px;
  }
  .divider_button {
    width: 100px;
  }
</style>
